import React, {useContext, useState} from 'react';
import Pagos from './pagos';
import Pendientes from './pendientes';
import { AuthContext } from "../../Auth.js"

function Actividades() {
    const { currentUser } = useContext(AuthContext)
    const [userName] = useState(currentUser.name)

    return (
    <div>
        <div>
            <Pendientes userName={userName} />
        </div>
        <div>
            <Pagos userName={userName} />
        </div>
    </div>
    )
}

export default Actividades;